const web_api_root_config = {
  QA: "https://jsw.qa.payex.live/api/",
  // QA_ALT: "https://axisqa.payex.live",
  // NEW_QA: "https://rearchqa.payex.live",
  UAT: "https://jsw.uat.payex.live/api/",
  // NEW_UAT: "https://rearchuat.payex.live",
  // PROD: "https://prod.payex.live",
  //LOCAL: "http://localhost:8090",
};
const web_api_admin_config = {
  QA: "https://admin.jsw.qa.payex.live/#/",
  // QA_ALT: "https://axisqa.payex.live",
  // NEW_QA: "https://rearchqa.payex.live",
  UAT: "https://admin.jsw.uat.payex.live/#/",
  // NEW_UAT: "https://rearchuat.payex.live",
  // PROD: "https://prod.payex.live",
  //LOCAL: "http://localhost:8090",
};
const overrideEnvironment = window["overrideEnvironment"];
const app_deploy_environment = "QA";
const web_api_path = "";
const web_api_root =
  overrideEnvironment && overrideEnvironment.basePath && (overrideEnvironment.basePath.indexOf("http://") !== -1 || overrideEnvironment.basePath.indexOf("https://") !== -1)
    ? overrideEnvironment.basePath
    : web_api_root_config[app_deploy_environment];
const web_api_admin =
  overrideEnvironment && overrideEnvironment.adminPath && (overrideEnvironment.adminPath.indexOf("http://") !== -1 || overrideEnvironment.adminPath.indexOf("https://") !== -1)
    ? overrideEnvironment.adminPath
    : web_api_admin_config[app_deploy_environment];
const externalLoginUrl = overrideEnvironment && overrideEnvironment.externalLoginUrl;
const WEB_TIME_OUT = overrideEnvironment && overrideEnvironment.WEB_TIME_OUT;
const appsBasePath = {};

if (overrideEnvironment && overrideEnvironment.apps) {
  Object.keys(overrideEnvironment.apps).forEach((appName) => {
    const appConfig = overrideEnvironment.apps[appName];
    if (appConfig.url) {
      appsBasePath[appName] = appConfig;
    }
  });
}

export const environment = {
  production: true,
  base: web_api_root,
  admin: web_api_admin,
  MANUAL_RECON_BASE_URL: "https://rearchqa.payex.live/algoriqapi/",
  // MANUAL_RECON_BASE_URL: 'https://rearchuat.payex.live/algoriqapi/',
  // MANUAL_RECON_BASE_URL: 'http://10.104.53.21:30000/algoriqapi/',
  API: {
    PayEXDC: appsBasePath["PayEXDC"] || {
      url: `${web_api_root}/${web_api_path}`,
    },
    PADD: appsBasePath["PADD"] || {
      url: `${web_api_root}/${web_api_path}`,
    },
    Algoriq: appsBasePath["Algoriq"] || {
      url: `${web_api_root}/${web_api_path}`,
    },
    Rearch: appsBasePath["Rearch"] || {
      url: `${web_api_root}/${web_api_path}`,
    },
    JSWAP: appsBasePath["JSWAP"] || {
      url: `${web_api_root}/${web_api_path}`,
    },
  },
  environment_name: app_deploy_environment,
  appName: "PayEXDC",
  externalLoginUrl: externalLoginUrl,
  environmentConfig: overrideEnvironment || {},
  deploymentInfo: {
    date: "2024-07-16",
    version: "v1.1",
    timestatmp: "",
  },
  dataUrl: (overrideEnvironment || {}).dataUrl || "https://empireimports.qa.payex.live/PayEXDCAPI/",
  gbsAPI: (overrideEnvironment || {}).gbsAPI || "https://uatedesk.jsw.in/JSW/api/ticket/",
  uploadedPdfsS3Prefix: (overrideEnvironment || {}).uploadedPdfsS3Prefix || "uploaded_pdfs",
  downloadedPdfsS3Prefix: (overrideEnvironment || {}).downloadedPdfsS3Prefix || "downloaded_pdfs",
  extractedPdfsS3Prefix: (overrideEnvironment || {}).extractedPdfsS3Prefix || "extracted_pdfs",
  s3: (overrideEnvironment || {}).s3 || {
    accessKeyId: "AKIA5DL5POTXXPAAQJOP",
    secretAccessKey: "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",
    bucket: "jsw-documents",
    region: "ap-south-1",
  },
};
